import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/achat/commande`;

export const createCommandeAchat = (data) => axios.post(`${API_BASE_URL}/create`, data);
export const saveCommandeAchat = (payload) => axios.put(`${API_BASE_URL}/save`, payload);
export const getCommandeAchat = (id) => axios.get(`${API_BASE_URL}/get/${id}`);
export const listCommandesAchat = (params) => axios.get(`${API_BASE_URL}/list`, { params });
export const getItemsInCommandeAchat = (id) => axios.get(`${API_BASE_URL}/items/${id}`);
export const addItemToCommandeAchat = (ref, item) => axios.post(`${API_BASE_URL}/item/${ref}`, item);
export const deleteItemFromCommandeAchat = (ref, lineId) => axios.delete(`${API_BASE_URL}/item/${ref}/${lineId}`);
export const validateCommandeAchat = (id) => axios.post(`${API_BASE_URL}/validate/${id}`);
export const transferCommandeToReception = (ref) => axios.post(`${API_BASE_URL}/transfer/${ref}`);
export const listDBFFiles = () => axios.get(`${API_BASE_URL}/dbf/list`);
export const importFromDBF = (fileName) => axios.post(`${API_BASE_URL}/dbf/import`, { fileName });
